import {
  faCoins,
  faSun,
  faSolarPanel,
  faBolt,
  faWarehouse,
  faInfoCircle,
  faCalendarAlt,
  faHandHoldingUsd,
  faMoneyBillWave
} from "@fortawesome/free-solid-svg-icons";

// Images
import web_image from "../../files/images/web_image.svg";
import app_image from "../../files/images/app_image.svg";
import smart_image from "../../files/images/smart_image.svg";
import logo from "../../files/images/logo-ercoenergia.png";
import icono from "../../files/images/icono.png";
import logoEpm from "../../files/images/epmLogo.png";
import epmIcono from "../../files/images/epmIcon.png";
import epm from "../../files/images/nuestroSocio.png";
import norfund from "../../files/images/norfund.png";
import payment_time from "../../files/images/payment_time.png";
import toneladas_CO2 from "../../files/images/toneladas_CO2.png";
import kms_dejados_de_recorrer from "../../files/images/kms_dejados_de_recorrer.png";
import arboles_sembrados from "../../files/images/arboles_sembrados.png";
import marcas from "../../files/images/marcas.jpg";
import best from "../../files/images/best.png";
import satisfaccion from "../../files/images/satisfaccion.png";
import gps from "../../files/images/gps.png";
import solar_panel from "../../files/images/solar-panel.png";
import expe_Pdf1 from "../../files/images/experiencePdf.jpg";
import backgroundEpm from "../../files/images/backgroundEpm.jpg";
import mapColEpm from "../../files/images/mapColEpm.png";
import epmG from "../../files/images/epmG.png";
import eltesoroG from "../../files/images/eltesoroG.png";
import bancolombiaG from "../../files/images/bancolombiaG.png";
import estraG from "../../files/images/estraG.png";
import eafitG from "../../files/images/eafitG.png";
import comfamaG from "../../files/images/comfamaG.png";
import partners1 from "../../files/images/partners1.png";
import partners2 from "../../files/images/partners2.png";
import co_pa_tx from "../../files/images/co_pa_tx.png";
import mapEPM2 from "../../files/images/mapColEpm2.png";
import commercialConditions from "../../files/images/comercialConditions.png";
import timePaymentTerms from "../../files/images/timePaymentTerms.png";
import AviancaImg from "../../files/images/Avianca.png";
import CIJEANSImg from "../../files/images/CIJEANS.png";
import EnsaImg from "../../files/images/Ensa.jpg";
import ExxonImg from "../../files/images/Exxon.png";
import isagenImg from "../../files/images/isagen.png";

/* EXPORTS */

// Images
export const epmAdviserPhoto = epmIcono;
export const adviserPhoto = icono;
export const ercoLogo = logo;
export const epmLogo = logoEpm;
export const paymentTime = payment_time;
export const socio = epm;
export const socio2 = norfund;
export const marcasImg = marcas;
export const first = best;
export const second = satisfaccion;
export const third = gps;
export const fourth = solar_panel;
export const exPdf1 = expe_Pdf1;
export const backEpm = backgroundEpm;
export const mapEpm = mapColEpm;
export const mapColEpm2 = mapEPM2;
export const epmGray = epmG;
export const eltesoroGray = eltesoroG;
export const bancolombiaGray = bancolombiaG;
export const estraGray = estraG;
export const eafitGray = eafitG;
export const comfamaGray = comfamaG;
export const partnersC = partners1;
export const partnersB = partners2;
export const CO_PA_TX = co_pa_tx;
export const commConditions = commercialConditions;
export const TPT_Pan = timePaymentTerms;
export const Avianca = AviancaImg;
export const CIJEANS = CIJEANSImg;
export const Ensa = EnsaImg;
export const Exxon = ExxonImg;
export const isagen = isagenImg;

// Icons
export const icon = faCoins;
export const infoIcon = faInfoCircle;
export const panelIcon = faSolarPanel;

// Text data
export const techData = [
  {
    title: "Web",
    titleEpm: "Sistema de monitoreo",
    content:
      "En esta plataforma podrás hacerle seguimiento a la generación de tu sistema solar. Aquí encontrarás indicadores de eficiencia,  ambientales y de ahorro, gráficas de generación y alarmas de desempeño.",
    bgColor: "#4FAC2E",
    bgImage: web_image
  },
  {
    title: "App",
    titleEpm: "Avance del proyecto",
    content:
      "En la app vas a poder tener a la mano, en tiempo real, los avances de la instalación de tu proyecto, sin la necesidad de estar presente en el sitio ni de subirte a los techos.",
    bgColor: "#92BD21",
    bgImage: app_image
  },
  {
    title: "Smart Meter",
    content:
      "Medidor de energía que con inteligencia artificial que procesa las mediciones de corriente y voltaje para detectar los dispositivos en estado encendido dentro de tus instalaciones.",
    bgColor: "#737373",
    bgImage: smart_image
  }
];

export const envImages = [
  toneladas_CO2,
  kms_dejados_de_recorrer,
  arboles_sembrados
];

export const comercialConsiderations = (guarantee, city) => {
  const years = Number(guarantee);
  const validatePan = city.includes("panama");

  if(validatePan) {
    return [
      "Paneles solares: Garantía de producto limitada de 10 años. Garantía de potencia limitada: 10 años al 91.2% de la potencia de salida mínima y 25 años al 80.7% de la potencia de salida mínima.",
      `Inversor de Potencia: ${numberToText(
        years
      )} (${guarantee}) años por defectos de fábrica.`,
      "Instalación: Cinco (5) años de garantía total.",
      "Estructura: Cinco (5) años de garantía total."
    ];
  }
  
  return [
    "Paneles solares: Garantía de producto limitada de 12 años. Garantía de potencia limitada: 12 años al 91.95% de la potencia de salida mínima y 25 años al 84% de la potencia de salida mínima.",
    `Inversor de Potencia: ${numberToText(
      years
    )} (${guarantee}) años por defectos de fábrica.`,
    "Instalación: Diez (10) años de garantía total.",
    "Estructura: Doce (12) años de garantía total."
  ];
  
};

export const termsAndConditions = (city) => {
  const validatePan = city.includes("panama");

  if(validatePan) {
    return [
      "La presente oferta es válida siempre y cuando el cliente cumpla con lo estipulado en la regulación Panameña referente el procedimiento para autoconsumo con fuentes nuevas, renovables y limpias; o cualquier otro reglamentación que aplique.",
      "El sistema planteado en esta oferta es interconectado a la red, por lo cual en caso de presentarse una interrupción en la red eléctrica convencional, el sistema solar no prestará servicio, la desconexión del sistema solar se hará de manera automática al igual que la reconexión al regresar el fluido eléctrico.",
      "Esta propuesta no contempla baterías para almacenamiento de energía, por lo cual no genera un respaldo en caso de ausencia del fluido eléctrico convencional.",
      "Las cubiertas deben estar en capacidad de soportar 15,5 kg/𝑚2 , en caso de plantearse sobre una loza esta debe soportar 45 kg/𝑚2 .",
      "Los valores de generación presentados en la propuesta son aproximados y pueden variar según el cambio de las condiciones climáticas en los diferentes meses del año.",
      "El porcentaje de impacto sobre los consumos es una valor de referencia calculado con los consumos suministrados por el cliente al momento de la fecha, en caso de aumentar o disminuir los consumos en el futuro este porcentaje se verá afectado, por lo cual no se garantiza este valor en el tiempo.",
      "Los valores económicos presentados en la precotización/cotización están sujetos a cambios en caso de requerirse modificaciones evidenciadas en la visita de viabilidad.",
      "La tipo de cubierta deberá ser compatible con la estructura del sistema solar, esto se define en el análisis a realizar por parte del equipo de Erco Energía y determinará la viabilidad del proyecto.",
      "La viabilidad del proyecto está sujeta a la presentación de un certificado estructural que avale la capacidad portante de la cubierta.",
      "No se incluye compensación de potencia reactiva, en caso de que aplique, esta se cotizara tan pronto se legalice el proyecto solar."
    ];
  }

  return [
    "La presente oferta es válida siempre y cuando el cliente cumpla con lo estipulado en la resolución CREG 038 de 2014 en articulo 19 sobre la ubicación de las fronteras comerciales, si el cliente no cumple con estas, se debe recalcular la cotización para tenerlo en cuenta o el cliente por su cuenta y riego realizar las respectivas modificaciones para cumplir.",
    "El sistema planteado en esta oferta es interconectado a la red, por lo cual en caso de presentarse una interrupción en la red eléctrica convencional, el sistema solar no prestará servicio, la desconexión del sistema solar se hará de manera automática al igual que la reconexión al regresar el fluido eléctrico.",
    "Esta propuesta no contempla baterías para almacenamiento de energía, por lo cual no genera un respaldo en caso de ausencia del fluido eléctrico convencional.",
    "Las cubiertas deben estar en capacidad de soportar 15,5 kg/𝑚2 , en caso de plantearse sobre una loza esta debe soportar 45 kg/𝑚2 .",
    "Los valores de generación presentados en la propuesta son aproximados y pueden variar según el cambio de las condiciones climáticas en los diferentes meses del año.",
    "El porcentaje de impacto sobre los consumos es una valor de referencia calculado con los consumos suministrados por el cliente al momento de la fecha, en caso de aumentar o disminuir los consumos en el futuro este porcentaje se verá afectado, por lo cual no se garantiza este valor en el tiempo.",
    "Los valores económicos presentados en la precotización/cotización están sujetos a cambios en caso de requerirse modificaciones evidenciadas en la visita de viabilidad.",
    "La tipo de cubierta deberá ser compatible con la estructura del sistema solar, esto se define en el análisis a realizar por parte del equipo de Erco Energía y determinará la viabilidad del proyecto.",
    "La viabilidad del proyecto está sujeta a la presentación de un certificado estructural que avale la capacidad portante de la cubierta.",
    "No se incluye compensación de potencia reactiva, en caso de que aplique, esta se cotizara tan pronto se legalice el proyecto solar."
  ];
  
}

export const investmentData = [
  {
    bgColor: "#92BD21",
    icon: faSun
  },
  {
    bgColor: "#4FAC2E",
    icon: faSolarPanel
  },
  {
    bgColor: "#DCDC24",
    icon: faBolt
  },
  {
    bgColor: "#737373",
    icon: faWarehouse
  }
];

export const EPCReturnData = [
  {
    bgColor: "#4FAC2E",
    icon: faCalendarAlt
  },
  {
    bgColor: "#92BD21",
    icon: faHandHoldingUsd
  },
  {
    bgColor: "#DCDC24",
    icon: faMoneyBillWave
  }
];

export const leasingReturnData = [
  {
    bgColor: "#4FAC2E",
    icon: faHandHoldingUsd
  },
  {
    bgColor: "#92BD21",
    icon: faCalendarAlt
  },
  {
    bgColor: "#DCDC24",
    icon: faMoneyBillWave
  },
  {
    bgColor: "#4FAC2E",
    icon: faHandHoldingUsd
  }
];

export const tooltipText = `
  Revisa las fichas técnicas de los equipos instalados
`;

export const tableHeaderInfo = [
  {
    label: "Año",
    tooltipText: "Período de evaluación del proyecto en años",
    units: "number"
  },
  {
    label: "Costo Energía [COP/kWh]",
    tooltipText:
      "Valor por cada kWh que paga el cliente al comercializador de energía",
    units: "cash"
  },
  {
    label: "Tarifa Comercialización",
    tooltipText:
      "Valor de reconocimiento de excedentes de energía<br /> de acuerdo a la regulación",
    units: "cash"
  },
  {
    label: "Producción Energía [kWh/año]",
    tooltipText: "Energía generada por el sistema solar al año",
    units: "number"
  },
  {
    label: "Energía Inyectada [kWh/año]",
    tooltipText:
      "Excedentes de energía. Es la energía que generó el sistema solar<br /> y no fue consumida por el cliente, ésta es exportada a la red",
    units: "number"
  },
  {
    label: "Energía Autoconsumida [kWh/año]",
    tooltipText:
      "Es la energía generada por el sistema solar y consumida por el cliente",
    units: "number"
  },
  {
    label: "Inversión [COP*1000]",
    tooltipText: "Valor total del proyecto IVA incluido",
    units: "cash"
  },
  {
    label: "Mantenimiento [COP*1000]",
    tooltipText:
      "Valor aproximado de los mantenimientos anuales que requiere<br /> el sistema solar para su óptimo funcionamiento",
    units: "cash"
  },
  {
    label: "Cargo por Respaldo",
    tooltipText:
      "Componente regulatorio exigido para proyectos >100 kW.<br /> El valor relacionado es un estimado ya que cada cliente decide la cantidad a respaldar<br /> directamente con el operador de red",
    units: "cash"
  },
  {
    label: "Ahorro Energía",
    tooltipText:
      "Ahorro que tendrá el cliente por la energía que genera el sistema solar y es autoconsumida,<br /> por lo tanto no requiere comprar esta cantidad de energía a su comercializador",
    units: "cash"
  },
  {
    label: "Ahorro Energía Inyectada",
    tooltipText:
      "Ahorro que tendrá el cliente por la energía generada del sistema solar y que no fue autoconsumida,<br /> fue exportada a la red; gracias a la regulación puede venderla",
    units: "cash"
  },
  {
    label: "Recuperación IVA [COP*1000]",
    tooltipText:
      "Este proyecto puede ser llevado contablemente como un activo fijo real productivo,<br /> por lo que se podrá descontar la totalidad del IVA del proyecto",
    units: "cash"
  },
  {
    label: "Beneficio especial ley 1715 [COP*1000]",
    tooltipText:
      "Deducción del 50% del valor de la inversión de la renta durante los primeros 15 años,<br /> sin superar en ningún caso el 50% de la renta líquida antes de la deducción del valor de la inversión.",
    units: "cash"
  },
  {
    label: "Depreciación acelerada [COP*1000]",
    tooltipText:
      "Como beneficio de la ley 1715 de 2014 y 2099 de 2021,<br /> el cliente podrá depreciar el activo aceleradamente en 3 o 5 años",
    units: "cash"
  },
  {
    label: "Flujo de caja [COP*1000]",
    tooltipText:
      "Resultado de los ingresos y egresos del proyecto en cada período de tiempo",
    units: "cash"
  },
  {
    label: "Flujo de caja acumulado [COP*1000]",
    tooltipText:
      "Resultado de los ingresos y egresos del proyecto acumulado al período de tiempo",
    units: "cash"
  }
];

export const tableHeaderInfoPanama = [
  {
    label: "Año",
    tooltipText: "Período de evaluación del proyecto en años",
    units: "number"
  },
  {
    label: "Costo Energía [USD/kWh]",
    tooltipText:
      "Valor por cada kWh que paga el cliente al comercializador de energía",
    units: "cash"
  },
  {
    label: "Producción Energía [kWh/año]",
    tooltipText: "Energía generada por el sistema solar al año",
    units: "number"
  },
  {
    label: "Inversión [USD]",
    tooltipText: "Valor total del proyecto ITBMS incluido",
    units: "cash"
  },
  {
    label: "Mantenimiento [USD]",
    tooltipText:
      "Valor aproximado de los mantenimientos anuales que requiere<br /> el sistema solar para su óptimo funcionamiento",
    units: "cash"
  },
  {
    label: "Ahorro Energía [USD]",
    tooltipText:
      "Ahorro que tendrá el cliente por la energía que genera el sistema solar y es autoconsumida,<br /> por lo tanto no requiere comprar esta cantidad de energía a su comercializador",
    units: "cash"
  },
  {
    label: "Flujo de caja [USD]",
    tooltipText:
      "Resultado de los ingresos y egresos del proyecto en cada período de tiempo",
    units: "cash"
  },
  {
    label: "Flujo de caja acumulado [USD]",
    tooltipText:
      "Resultado de los ingresos y egresos del proyecto acumulado al período de tiempo",
    units: "cash"
  }
];

export const tableLeasingInfo = [
  {
    label: "Año",
    tooltipText: "Período de evaluación del proyecto en años",
    units: "number"
  },
  {
    label: "Tarifa impuesto",
    tooltipText: "",
    units: "%"
  },
  {
    label: "Proyección aumento tarifa",
    tooltipText: "",
    units: "%"
  },
  {
    label: "Tarifa energía sustituida (COP/kWh)",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "Tarifa excedentes",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "Excedentes de energía (kWh)",
    tooltipText: "",
    units: "number"
  },
  {
    label: "Producción (kWh)",
    tooltipText: "",
    units: "number"
  },
  {
    label: "Ahorro pago energía",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "Venta excedentes",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "O & M",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "Seguro",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "Cargo por respaldo",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "Cuota",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "Capital",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "Interés",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "Opción de compra",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "BT Depreciación",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "BT Intereses",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "BT Gastos",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "Descuento IVA en compras",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "BT Ley 1715",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "Flujo de caja Energía Solar",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "Pago energía tradicional",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "BT Pago energía",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "Flujo de caja",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "Flujo neto proyecto",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "Tarifa energía solar (COP/kWh)",
    tooltipText: "",
    units: "cash"
  },
  {
    label: "Energía tradicional (COP/kWh)",
    tooltipText: "",
    units: "cash"
  }
];

export const leasingTableGroups = (
  vpnSolarSystem = 0,
  vpnTraditionalEnergy = 0,
  vpnProject = 0
) => {
  const grayColor = "#BFBFBF";
  const blueColor = "#9BC2E6";
  const greenColor = "#70AD47";

  const group0 = {
    Header: " ",
    backgroundColor: grayColor,
    textColor: "#000",
    width: "100px",
    tooltipText: "",
    columns: [
      {
        Header: "Año",
        units: "number",
        tooltipText: ""
      }
    ]
  };

  const group1 = {
    Header: "Datos Sistema Solar",
    backgroundColor: grayColor,
    textColor: "#000",
    width: "750px",
    tooltipText: "",
    columns: [
      {
        Header: "Tarifa energía sustituida (COP/kWh)",
        units: "cash",
        tooltipText: ""
      },
      {
        Header: "Tarifa excedentes",
        units: "cash",
        tooltipText: ""
      },
      {
        Header: "Excedentes de energía (kWh)",
        units: "number",
        tooltipText: ""
      },
      {
        Header: "Energía Autoconsumida (kWh)",
        units: "number",
        tooltipText: ""
      }
    ]
  };

  const group2 = {
    Header: "Costos Sistema Solar",
    backgroundColor: blueColor,
    textColor: "#000",
    width: "650px",
    tooltipText: "",
    columns: [
      {
        Header: "O & M",
        units: "cash",
        tooltipText: ""
      },
      {
        Header: "Seguro",
        units: "cash",
        tooltipText: ""
      },
      {
        Header: "Cargo por respaldo",
        units: "cash",
        tooltipText: ""
      },
      {
        Header: "Cuota",
        units: "cash",
        tooltipText: ""
      },
      {
        Header: "Opcion de compra",
        units: "cash",
        tooltipText: ""
      }
    ]
  };

  const group3 = {
    Header: "Descuentos Tributarios Sistema Solar",
    backgroundColor: greenColor,
    textColor: "#000",
    width: "650px",
    tooltipText: "",
    columns: [
      {
        Header: "BT Depreciación",
        units: "cash",
        tooltipText: ""
      },
      {
        Header: "BT Intereses",
        units: "cash",
        tooltipText: ""
      },
      {
        Header: "BT Gastos",
        units: "cash",
        tooltipText: ""
      },
      {
        Header: "Descuento IVA en compras",
        units: "cash",
        tooltipText: ""
      },
      {
        Header: "BT Ley 1715",
        units: "cash",
        tooltipText: ""
      }
    ]
  };

  const group4 = {
    Header: `VPN Sistema Solar`,
    Header2: vpnSolarSystem,
    backgroundColor: grayColor,
    textColor: "#000",
    width: "180px",
    tooltipText: "",
    columns: [
      {
        Header: "Flujo de caja Energía Solar",
        units: "cash",
        tooltipText: ""
      }
    ]
  };

  const group5 = {
    Header: "Costos Energía Tradicional",
    backgroundColor: blueColor,
    textColor: "#000",
    width: "180px",
    tooltipText: "",
    columns: [
      {
        Header: "Pago Energía Tradicional",
        units: "cash",
        tooltipText: ""
      }
    ]
  };

  const group6 = {
    Header: "Descuentos Tributarios Energía Tradicional",
    backgroundColor: greenColor,
    textColor: "#000",
    width: "180px",
    tooltipText: "",
    columns: [
      {
        Header: "BT Pago Energía",
        units: "cash",
        tooltipText: ""
      }
    ]
  };

  const group7 = {
    Header: `VPN Energía Tradicional`,
    Header2: vpnTraditionalEnergy,
    backgroundColor: grayColor,
    textColor: "#000",
    width: "180px",
    tooltipText: "",
    columns: [
      {
        Header: "Flujo de caja",
        units: "cash",
        tooltipText: ""
      }
    ]
  };

  const group8 = {
    Header: "VPN Proyecto \n",
    Header2: vpnProject,
    backgroundColor: grayColor,
    textColor: "#000",
    width: "180px",
    tooltipText: "",
    columns: [
      {
        Header: "Flujo neto proyecto",
        units: "cash",
        tooltipText: ""
      }
    ]
  };

  const group9 = {
    Header: "Comparativo Tarifa Energía",
    backgroundColor: grayColor,
    textColor: "#000",
    width: "280px",
    tooltipText: "",
    columns: [
      {
        Header: "Tarifa Energía Solar (COP/kWh)",
        units: "cash",
        tooltipText: ""
      },
      {
        Header: "Energía Tradicional (COP/kWh)",
        units: "cash",
        tooltipText: ""
      }
    ]
  };

  const group10 = {
    Header: "Ahorros Sistema Solar",
    backgroundColor: grayColor,
    textColor: "#000",
    width: "280px",
    tooltipText: "",
    columns: [
      {
        Header: "Ahorro pago Energía",
        units: "cash",
        tooltipText: ""
      },
      {
        Header: "Venta Excedentes",
        units: "cash",
        tooltipText: ""
      }
    ]
  };

  return [
    group0,
    group1,
    group2,
    group3,
    group4,
    group5,
    group6,
    group7,
    group8,
    group9,
    group10
  ];
};

// Styles
export const selectStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    borderColor: "#bebcbc",
    boxShadow: "0",
    color: "#737373",
    ":hover": {
      ...styles[":hover"],
      boxShadow: "0 0 0 1px #50ac2ed3",
      borderColor: "#50ac2ed3",
      cursor: "pointer"
    }
  }),
  option: (styles, { isFocused }) => {
    const color = "#50ac2ed3";
    return {
      ...styles,
      backgroundColor: isFocused ? color : "white",
      cursor: "pointer",
      color: isFocused ? "#fff" : "#737373",
      ":active": {
        ...styles[":active"],
        backgroundColor: color,
        color: "#fff"
      }
    };
  },
  placeholder: (styles) => ({
    ...styles,
    color: "#737373"
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#737373"
  })
};

export const selectDocStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "#92BD21",
    borderColor: "#92BD21",
    boxShadow: "0",
    color: "#fff",
    ":hover": {
      ...styles[":hover"],
      boxShadow: "0 0 0 1px #50ac2ed3",
      borderColor: "#50ac2ed3",
      cursor: "pointer"
    }
  }),
  option: (styles, { isFocused }) => {
    const color = "#50ac2ed3";
    return {
      ...styles,
      backgroundColor: isFocused ? color : "white",
      cursor: "pointer",
      color: isFocused ? "#fff" : "#737373",
      ":active": {
        ...styles[":active"],
        backgroundColor: color,
        color: "#fff"
      }
    };
  },
  indicatorSeparator: (styles) => ({
    ...styles,
    display: "none"
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    color: "#fff"
  }),
  placeholder: (styles) => ({
    ...styles,
    width: "100%",
    textAlign: "center",
    color: "#fff"
  }),
  singleValue: (styles) => ({
    ...styles,
    width: "100%",
    textAlign: "center",
    color: "#fff"
  })
};

// Functions
export const getQuoteVersion = () => {
  const url = window.location.href;
  let version = url.split("/").pop().trim();
  version = version.split("#").shift().trim();
  return version;
};

export const getClientId = () => {
  const url = window.location.href;
  let version = url.split("/").slice(-2);
  version = version.shift().trim();
  return version;
};

export const getDate = (fecha_expiracion) => {
  let fullDate = fecha_expiracion;
  fullDate = fullDate.split("-");

  fullDate =
    fullDate[2] + " " + getFullMonth(fullDate[1]) + " de " + fullDate[0];
  return fullDate;
};

export const getFormattedDate = (source) => {
  const date = new Date(source);
  const day = date.getDate().toString().padStart(2, '0');
  const monthIndex = date.getMonth();
  const year = date.getFullYear().toString();

  const months = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];
  const month = months[monthIndex];

  return `${day} de ${month} de ${year}`;
};


export const validateDate = (fecha_expiracion) => {
  const date = new Date();
  let today = date.toDateString().split(" ").slice(1, 4);
  today = today[2] + "-" + convertMonth(today[0]) + "-" + today[1];

  const currentDate = Date.parse(today);
  const dateToVerify = Date.parse(fecha_expiracion);

  if (dateToVerify >= currentDate) {
    return false;
  } else {
    return true;
  }
};

function convertMonth(month) {
  let fullMonth = month;

  fullMonth = fullMonth.replace("Jan", "01");
  fullMonth = fullMonth.replace("Feb", "02");
  fullMonth = fullMonth.replace("Mar", "03");
  fullMonth = fullMonth.replace("Apr", "04");
  fullMonth = fullMonth.replace("May", "05");
  fullMonth = fullMonth.replace("Jun", "06");
  fullMonth = fullMonth.replace("Jul", "07");
  fullMonth = fullMonth.replace("Aug", "08");
  fullMonth = fullMonth.replace("Sep", "09");
  fullMonth = fullMonth.replace("Oct", "10");
  fullMonth = fullMonth.replace("Nov", "11");
  fullMonth = fullMonth.replace("Dec", "12");

  return fullMonth;
}

function getFullMonth(month) {
  let fullMonth = month;

  fullMonth = fullMonth.replace("01", "Enero");
  fullMonth = fullMonth.replace("02", "Febrero");
  fullMonth = fullMonth.replace("03", "Marzo");
  fullMonth = fullMonth.replace("04", "Abril");
  fullMonth = fullMonth.replace("05", "Mayo");
  fullMonth = fullMonth.replace("06", "Junio");
  fullMonth = fullMonth.replace("07", "Julio");
  fullMonth = fullMonth.replace("08", "Agosto");
  fullMonth = fullMonth.replace("09", "Septiembre");
  fullMonth = fullMonth.replace("10", "Octubre");
  fullMonth = fullMonth.replace("11", "Noviembre");
  fullMonth = fullMonth.replace("12", "Diciembre");

  return fullMonth;
}

function unidades(unidad) {
  let unidades = [
    "UN ",
    "DOS ",
    "TRES ",
    "CUATRO ",
    "CINCO ",
    "SEIS ",
    "SIETE ",
    "OCHO ",
    "NUEVE "
  ];
  return unidades[unidad - 1];
}

function decenas(decena, unidad) {
  let diez = [
    "ONCE ",
    "DOCE ",
    "TRECE ",
    "CATORCE ",
    "QUINCE",
    "DIECISEIS ",
    "DIECISIETE ",
    "DIECIOCHO ",
    "DIECINUEVE "
  ];
  let decenas = [
    "DIEZ ",
    "VEINTE ",
    "TREINTA ",
    "CUARENTA ",
    "CINCUENTA ",
    "SESENTA ",
    "SETENTA ",
    "OCHENTA ",
    "NOVENTA "
  ];

  if (decena === 0 && unidad === 0) {
    return "";
  }

  if (decena === 0 && unidad > 0) {
    return unidades(unidad);
  }

  if (decena === 1) {
    if (unidad === 0) {
      return decenas[decena - 1];
    } else {
      return diez[unidad - 1];
    }
  } else if (decena === 2) {
    if (unidad === 0) {
      return decenas[decena - 1];
    } else if (unidad === 1) {
      return "VEINTI UNO";
    } else {
      return "VEINTI" + unidades(unidad);
    }
  } else {
    if (unidad === 0) {
      return decenas[decena - 1] + " ";
    }
    if (unidad === 1) {
      return `${decenas[decena - 1]} Y UNO`;
    }

    return decenas[decena - 1] + "Y " + unidades(unidad);
  }
}

const numberToText = (total) => {
  let numero = 0;
  let arreglo = total.toString().replace(/\./, "");
  let longitud = arreglo.length;

  switch (longitud) {
    case 1:
      numero = unidades(Number(arreglo[0]));
      break;
    case 2:
      numero = decenas(Number(arreglo[0]), Number(arreglo[1]));
      break;
    default:
      break;
  }

  return numero;
};

export const content = [
  {
    id: 1,
    icono: first,
    textGreen: "Más de 10 años",
    textGrey: "de experiencia."
  },
  {
    id: 2,
    icono: second,
    textGreen: "Más de 2300",
    textGrey: "clientes felices."
  },
  {
    id: 3,
    icono: third,
    textGreen: "Más de 85 MWp",
    textGrey: "instalados."
  },
  {
    id: 4,
    icono: fourth,
    textGreen: "Cobertura",
    textGrey: "Nacional e internacional."
  }
];

export const DeviceSize = {
  mobile: 768,
  tablet: 992,
  laptop: 1324,
  desktop: 2024
};

export const validateAllowView = (allowROI) => {
  let allowView = allowROI;
  if (typeof allowView === "undefined") {
    allowView = true;
  }
  return allowView;
};

export const ignoreZohoRegistry = () => {
  const url = window.location.href;
  const ignoreZoho = url.includes("commercial") ? true : false;
  return ignoreZoho;
};

//Svg's

export const lightBulb = (
  <svg
    className="absolute right-0 bottom-0 z-0 text-9xl"
    width="530"
    height="620"
    viewBox="0 0 119 139"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57.2848 138.208C55.6698 137.591 53.4246 135.161 52.5703 133.422L51.8606 131.976L51.7065 118.133C51.5623 105.182 51.5166 104.127 50.9985 101.75C49.2957 93.9415 46.0426 87.6196 40.8179 81.9658C36.8432 77.6647 34.6972 74.6496 32.5179 70.3042C30.0027 65.2889 28.5192 60.6859 27.7054 55.3722C27.1641 51.8372 27.1679 44.9437 27.7134 41.4253C30.5366 23.2082 42.9821 8.35623 60.2671 2.57707C66.1685 0.603976 67.456 0.421048 75.4828 0.415299C81.9635 0.410699 82.8316 0.461892 85.2618 0.992455C98.5381 3.89086 109.534 11.5871 116.664 22.9713L118.279 25.5503L118.282 48.3062L118.285 71.0622L117.014 73.177C115.342 75.9589 113.576 78.2816 110.564 81.662C105.178 87.7059 102.03 93.661 100.215 101.242C99.7004 103.389 99.6572 104.381 99.5073 117.498C99.36 130.393 99.3109 131.556 98.8693 132.611C97.8182 135.123 95.7164 137.22 93.5265 137.943L92.6992 138.216C57.1903 137.83 93.621 138.321 57.2848 138.208V138.208ZM91.7114 132.226C93.3715 131.438 93.3896 131.325 93.3896 121.714V113.053H75.6096H57.8296V121.887C57.8296 129.637 57.8803 130.793 58.2432 131.311C59.1394 132.59 59.145 132.591 75.5712 132.601C88.7573 132.61 91.0132 132.557 91.7114 132.226ZM64.9416 88.5755V70.1938L62.3381 70.0749C60.2132 69.9778 59.4772 69.8335 58.3344 69.2897C56.5351 68.4335 54.9598 66.8644 54.0987 65.0707C53.5204 63.8658 53.4144 63.3025 53.4007 61.3592C53.386 59.2648 53.4563 58.9224 54.2208 57.3694C55.7319 54.2993 58.0818 52.8328 61.7666 52.6602C64.6681 52.5242 66.3604 53.0954 68.2133 54.8361C70.0832 56.5928 70.8348 58.4104 70.9855 61.5401L71.1055 64.0313H75.4796H79.8537L79.993 61.5045C80.1597 58.4791 80.8332 56.7619 82.5108 55.0853C84.3185 53.2786 85.7163 52.7361 88.5636 52.7361C91.4109 52.7361 92.8087 53.2786 94.6163 55.0853C96.3201 56.7881 97.0447 58.6177 97.0526 61.2373C97.0586 63.0849 96.9537 63.6267 96.328 64.9943C94.8305 68.2669 91.7305 70.1273 87.7748 70.1273H86.0236V88.5423V106.957H89.691H93.3585L93.5116 105.751C94.2658 99.8072 95.266 95.8336 97.072 91.6055C99.5435 85.819 101.423 83.0513 108.091 75.3819C111.218 71.785 114.225 66.3314 115.821 61.3643C117.412 56.4119 117.647 54.6993 117.639 48.1563C117.632 42.6576 117.59 42.1351 116.917 39.2663C114.681 29.7272 109.578 21.4494 102.362 15.6572C96.6031 11.0341 91.0676 8.38611 83.9063 6.82845C80.3735 6.06002 71.3942 5.99405 67.8626 6.71058C54.5601 9.40956 43.5832 17.8191 37.6351 29.8683C34.3718 36.4788 33.3301 41.0125 33.3458 48.5373C33.3548 52.8973 33.4367 53.8735 34.0297 56.6911C35.204 62.2714 37.0344 66.7681 39.9438 71.2202C41.5307 73.6484 42.6858 75.0887 46.8082 79.7793C52.6176 86.3893 56.6506 95.9269 57.4681 104.989L57.6457 106.957H61.2936H64.9416V88.5755ZM105.013 50.9336C104.136 50.4576 103.55 49.34 103.55 48.1435C103.55 47.4279 103.747 47.0195 104.413 46.3529C105.15 45.6157 105.452 45.4893 106.471 45.4893C107.49 45.4893 107.791 45.6157 108.528 46.3529C109.247 47.0719 109.392 47.4025 109.392 48.3283C109.392 49.5979 108.922 50.4051 107.865 50.9517C106.944 51.4278 105.912 51.4212 105.013 50.9336V50.9336ZM102.602 39.2605C102.299 39.0478 101.343 37.5059 100.479 35.8342C95.6876 26.5639 87.1988 20.9884 77.0066 20.4172C74.1718 20.2584 73.2588 19.9219 72.6929 18.8276C71.6584 16.827 72.6559 14.7915 74.8739 14.377C76.146 14.1393 80.97 14.688 83.7567 15.3873C93.2864 17.7788 101.525 24.3937 105.906 33.1703C107.569 36.502 107.581 37.8211 105.959 39.0966C105.124 39.7538 103.425 39.8367 102.602 39.2605H102.602ZM79.9276 88.5423V70.1273H75.4826H71.0376V88.5423V106.957H75.4826H79.9276V88.5423ZM64.9416 62.0339C64.9416 60.2269 64.8793 59.9742 64.2881 59.383C63.0933 58.1882 61.2019 58.1882 60.0071 59.383C59.4815 59.9087 59.3536 60.282 59.3536 61.2914C59.3536 62.3398 59.4758 62.6686 60.0961 63.2888C60.7941 63.9869 60.9612 64.0313 62.8901 64.0313H64.9416V62.0339ZM90.3611 63.2888C91.4124 62.2376 91.4151 60.5779 90.3671 59.4055C89.7581 58.7239 89.447 58.5818 88.5631 58.5818C87.6793 58.5818 87.3682 58.7239 86.7592 59.4055C86.0861 60.1588 86.0231 60.3918 86.0231 62.1303V64.0313H87.8207C89.4688 64.0313 89.68 63.9696 90.3607 63.2888H90.3611ZM14.9649 82.4906C13.7242 81.8016 13.1761 80.2328 13.73 78.9559C14.1782 77.9225 20.1157 72.0234 21.063 71.6703C22.058 71.2993 23.1975 71.6022 24.0629 72.4676C24.6952 73.1 24.8096 73.414 24.8096 74.5183V75.8222L21.3071 79.3247C17.8424 82.7894 17.7923 82.8272 16.6716 82.8183C16.0484 82.8133 15.2804 82.6659 14.9649 82.4906ZM1.80234 50.8523C0.186161 49.8668 -0.000618994 47.4835 1.43677 46.1878L2.2116 45.4893H7.25333C11.8815 45.4893 12.3472 45.5303 12.93 45.9886C14.4465 47.1815 14.47 49.2433 12.9819 50.5499L12.0919 51.3313L7.33823 51.3303C3.13557 51.3295 2.4939 51.2741 1.80233 50.8523L1.80234 50.8523ZM20.6186 24.877C20.3392 24.7248 18.7077 23.2138 16.993 21.5193C13.4265 17.9946 13.0068 17.2096 13.8103 15.5659C14.4127 14.3334 15.7488 13.603 16.9789 13.8338C17.706 13.9702 18.5305 14.652 21.1127 17.2518C22.8867 19.0381 24.4425 20.6644 24.57 20.8659C24.6975 21.0674 24.8036 21.7295 24.8057 22.3372C24.8087 23.2578 24.6655 23.5861 23.946 24.3057C23.2579 24.9937 22.8836 25.1677 22.1045 25.1615C21.5666 25.1573 20.898 25.0293 20.6186 24.877V24.877Z"
      fill="#F2F2F2"
    />
  </svg>
);

const calculateVNA = (tasa_oportunidad, column, years) => {
  let vna;
  let vp = [];

  for (let i = 1; i <= years; i++) {
    const value = Math.round(column[i]) / Math.pow(1 + tasa_oportunidad, i);
    vp.push(value);
  }

  if (vp.length > 0)
    vna = vp.reduce((accumulator, currentValue) => accumulator + currentValue);

  return vna;
};

export const calculateLeasingVPN = (netCashFlow, tasa_oportunidad, years) => {
  let vpn = calculateVNA(tasa_oportunidad / 100, netCashFlow, years);
  // vpn = Math.round(vpn / 1000);
  vpn = Math.round(vpn);

  return vpn;
};

export const panama = ["panama", "panama otros"];

export const formatNumber = (number) => {
  const num = Number(number);
  const options = { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: true };
  
  // return num.toLocaleString('es', options).replace(/,00/, '');
  const newNum = num.toLocaleString('es', options).replace(/\./g, '_').replace(/,/g, '.').replace(/_/g, ',');
  // return newNum;
  return newNum.replace(/\.00/, '');
}

export const formatCurrency = (number) => {
    let num = parseFloat(number);

    if (isNaN(num) && typeof number === 'string') {
        num = parseFloat(number.replace(/[^\d-]/g, ''));
    }
    // const type = currency ? "es-CO" : 'es';
    const options = {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true,
    };

    // return num.toLocaleString("es-CO", options).replace(/,00/, '');
    const newNum = num.toLocaleString("es-CO", options).replace(/\./g, '_').replace(/,/g, '.').replace(/_/g, ',');
    return newNum.replace(/\.00/, '');
};
